import styles from "@/styles/components/StatPanel.module.css"

/**
 * The debrief's right-hand column: a stack of value-over-label rows.
 *
 * Every value is derived at render — the shortlist's length, the Must-have
 * count, the bucket's own "when" string. Nothing here is a stored number, and
 * adding one would be a second copy of a fact the job documents already hold.
 */

export interface Stat {
  value: string
  label: string
}

interface StatPanelProps {
  stats: readonly Stat[]
}

export default function StatPanel({ stats }: StatPanelProps) {
  return (
    <dl className={styles.panel}>
      {stats.map((stat) => (
        <div className={styles.row} key={stat.label}>
          {/* Term then definition, read in that order; the value is lifted above
              the label in CSS. The other way round announces the pair backwards. */}
          <dt className={styles.label}>{stat.label}</dt>
          <dd className={styles.value}>{stat.value}</dd>
        </div>
      ))}
    </dl>
  )
}
